import type { TPhrases } from '@semios/app-platform-i18n-core'
import { translate } from 'i18n/i18n'
import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'
import type { TInsectId } from 'stores/fieldAssetStore/helperTypes'

export const getInsectNameFromId = (insectId?: TInsectId) => {
  const fallBackName = translate.phrases.banyanApp('Unknown Insect')

  if (!insectId) return fallBackName

  const englishInsectName = fieldAssetStore.getState()?.insects?.[insectId]?.name

  if (!englishInsectName) return fallBackName

  return translate.phrases.dbInsectName(englishInsectName as TPhrases['dbInsectName'])
}
